// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.ClientRequestContext
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { AbstractClientRequestContext } from "abweb/dto/ds/AbstractClientRequestContext";
import { ClientFieldSpec } from "abweb/dto/ds/ClientFieldSpec";
import { ClientFilterSpec } from "abweb/dto/ds/ClientFilterSpec";
import { ClientSortSpec } from "abweb/dto/ds/ClientSortSpec";
import { ContentRestriction } from "abweb/dto/ds/ContentRestriction";
import { HistoricalPointInTime } from "abweb/dto/ds/HistoricalPointInTime";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class ClientRequestContextBase extends AbstractClientRequestContext {
  /** Do NOT invoke directly, instead use strongly typed createClientRequestContextBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.ClientRequestContext";
  }
  initFromJson(json, deserializeContext) {
    this.initClientRequestContext(TSOGUtils.decodeObject(json.historicalPointInTime, HistoricalPointInTime, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "historicalPointInTime")), json.contentRestrictions != null ? TSOGUtils.decodeObjectArray(json.contentRestrictions, ContentRestriction, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "contentRestrictions")) : null, json.fieldSpecs != null ? TSOGUtils.decodeObjectArray(json.fieldSpecs, ClientFieldSpec, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "fieldSpecs")) : null, json.filterSpecs != null ? TSOGUtils.decodeObjectArray(json.filterSpecs, ClientFilterSpec, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "filterSpecs")) : null, json.refreshExpression != null ? json.refreshExpression : null, json.refreshInterval, json.runQuery, json.sortSpecs != null ? TSOGUtils.decodeObjectArray(json.sortSpecs, ClientSortSpec, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "sortSpecs")) : null);
  }
  initClientRequestContext(historicalPointInTime, contentRestrictions, fieldSpecs, filterSpecs, refreshExpression, refreshInterval, runQuery, sortSpecs) {
    this.initAbstractClientRequestContext(historicalPointInTime);
    this._contentRestrictions = contentRestrictions;
    this._fieldSpecs = fieldSpecs;
    this._filterSpecs = filterSpecs;
    this._refreshExpression = refreshExpression;
    this._refreshInterval = refreshInterval;
    this._runQuery = runQuery;
    this._sortSpecs = sortSpecs;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["contentRestrictions"] = TSOGUtils.toTSOGArray(this._contentRestrictions, serializeContext);
    retVal["fieldSpecs"] = TSOGUtils.toTSOGArray(this._fieldSpecs, serializeContext);
    retVal["filterSpecs"] = TSOGUtils.toTSOGArray(this._filterSpecs, serializeContext);
    retVal["refreshExpression"] = this._refreshExpression;
    retVal["refreshInterval"] = this._refreshInterval;
    retVal["runQuery"] = this._runQuery;
    retVal["sortSpecs"] = TSOGUtils.toTSOGArray(this._sortSpecs, serializeContext);
    return retVal;
  }
  get contentRestrictions() {
    return this._contentRestrictions;
  }
  set contentRestrictions(value) {
    this._contentRestrictions = value;
  }
  get fieldSpecs() {
    return this._fieldSpecs;
  }
  set fieldSpecs(value) {
    this._fieldSpecs = value;
  }
  get filterSpecs() {
    return this._filterSpecs;
  }
  set filterSpecs(value) {
    this._filterSpecs = value;
  }
  get refreshExpression() {
    return this._refreshExpression;
  }
  set refreshExpression(value) {
    this._refreshExpression = value;
  }
  get refreshInterval() {
    return this._refreshInterval;
  }
  set refreshInterval(value) {
    this._refreshInterval = value;
  }
  get runQuery() {
    return this._runQuery;
  }
  set runQuery(value) {
    this._runQuery = value;
  }
  get sortSpecs() {
    return this._sortSpecs;
  }
  set sortSpecs(value) {
    this._sortSpecs = value;
  }
}
//# sourceMappingURL=ClientRequestContextBase.js.map
